import BigDCampgroundData from "../../../../src/components/big-d-campground-data.js";
import * as React from 'react';
export default {
  BigDCampgroundData,
  React
};